function Footer() {
  return (
    <footer>
      <p>
        JY CEO.kwon jae yeon
        <br />
        Business License.
        <br />
        [777-23-01151] On-Line Register.
        <br />
        2022-서울 용산-1407[사업자정보확인]
        <br />
        04316 46-10,
        <br />
        Wonhyo-ro 1-ga, Yongsan-gu, Seoul 6 Floor
        <br />
        kakaotalk ID : nff
        <br />
        11AM-17PM
        <br />
        jy.nff.official@gmail.com
        <br />
        개인정보관리책임자 kwon jae yeon
        <br />
        기업은행 025-136582-04-018 kwon jaeyeon
      </p>
    </footer>
  );
}

export default Footer;
